import { useTranslation } from 'react-i18next';
import type { AiUsageSummary } from '@bliks-io/contracts';

interface AiUsageWarningsProps {
  summary: AiUsageSummary | undefined;
  failedTenantCount?: number;
}

/** Data-quality caveats for the cost figures: events priced at 0 for lack of
 *  a price row, and tenants the overview fan-out could not read. */
export function AiUsageWarnings({ summary, failedTenantCount = 0 }: AiUsageWarningsProps) {
  const { t } = useTranslation();

  return (
    <>
      {(summary?.priceMissingCount ?? 0) > 0 && (
        <p className="text-sm text-warning">
          {t('aiUsage.priceMissingWarning', { count: summary?.priceMissingCount })}
        </p>
      )}
      {failedTenantCount > 0 && (
        <p className="text-sm text-destructive">
          {t('aiUsage.failedTenantsWarning', { count: failedTenantCount })}
        </p>
      )}
    </>
  );
}
